import { bodyBgWidth } from './BodyBgStore';

import { bodyBgWidthDefault } from './BodyBgStoreDefaults';

export const resetBodyBgWidth = () => bodyBgWidth.set(bodyBgWidthDefault);
